import BaseAlert, { AlertProps as BaseAlertProps } from 'antd/lib/alert'

export interface AlertProps extends BaseAlertProps {}

export const Alert = (props: AlertProps): JSX.Element => {
  return <BaseAlert {...props} />
}
